// extracted by mini-css-extract-plugin
export default {"block":"TextFooter_block__URvMZ"};